<template>
  <div class="page page-blue">
    <!--<pre>
      {{ msg }}
    </pre>
    <ui-button type="primary" @click="proceedLogin">Продолжить</ui-button>-->
  </div>
</template>

<script>
import jwt from "jwt-decode";

export default {
  name: "Authorize",
  data() {
    return {
      msg: "",
      jwt: ""
    };
  },
  created() {
    // Получаем jwt-токен
    try {
      let jwtRaw = window.location.hash;
      jwtRaw = jwtRaw.replace("#", "").split("&");
      this.jwt = jwtRaw[0].split("=")[1];
      this.state = jwtRaw[1].split("=")[1];
      this.msg = jwt(this.jwt);
    } catch (e) {
      console.log(e);
      let body = new FormData();
      body.append("data", window.location.hash);
      this.axios
        .post(process.env.VUE_APP_API_ROOT + "login-error-log", body, {
          headers: {}
        })
        .then(() => {
          this.$router.push("/401");
        });
    }
    return this.proceedLogin();
  },
  methods: {
    proceedLogin() {
      try {
        console.log(this.jwt);
        // Пока консоль лог оставляем, чтобы проверять, отвалилось ли что-то или нет
        console.log(this.msg);
        // Берем jwt-токен и пересылаем на бекенд
        let body = new FormData();
        body.append("jwt_token", this.jwt);
        this.axios
          .post(process.env.VUE_APP_API_ROOT + "/authorize", body, {})
          .then(r => {
            if (r.data.status === "error") {
              console.error(r.data.message);
              return this.$router.push("/403");
            }
            const data = r.data.result;
            this.$store.commit("setUser", data.abo);
            this.$store.commit("setTemplates", data.templates);
            this.$store.commit("setPage", data.page);
            this.$router.push("/");
          });
      } catch (e) {
        this.$router.push("/401");
      }
    }
  }
};
</script>

<style scoped></style>
